module.exports = __webpack_public_path__ + "img/IMG-20190905-WA0017.5ee9019f.jpg";